"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSegmentAnalyticsHandler = exports.useSegment = void 0;
const tslib_1 = require("tslib");
const analytics_next_1 = require("@segment/analytics-next");
const react_1 = require("react");
const context_to_options_1 = require("./context-to-options");
const page_name_1 = tslib_1.__importDefault(require("./plugins/page-name"));
const track_event_1 = require("./track-event");
const useSegment = ({ writeKey, cdnURL, }) => {
    return (0, react_1.useMemo)(() => {
        if (!writeKey) {
            return null;
        }
        return analytics_next_1.AnalyticsBrowser.load({
            writeKey,
            cdnURL: cdnURL || undefined,
            plugins: [page_name_1.default],
        }, {
            obfuscate: true,
            retryQueue: true,
        });
    }, [writeKey, cdnURL]);
};
exports.useSegment = useSegment;
const useSegmentAnalyticsHandler = ({ writeKey, cdnURL, transformLegacyEventForSegment, }) => {
    const segment = (0, exports.useSegment)({ writeKey, cdnURL });
    const transformLegacyEvent = (0, react_1.useCallback)((event) => transformLegacyEventForSegment?.(event) ?? null, [transformLegacyEventForSegment]);
    return (0, react_1.useMemo)(() => ({
        async setUserId(userId) {
            const user = await segment?.user();
            if (userId) {
                if (user && userId === user.id()) {
                    return;
                }
                await segment?.identify(userId);
            }
            else {
                if (!user) {
                    return;
                }
                const currentId = user.id();
                if (currentId) {
                    await segment?.reset();
                }
            }
        },
        async trackEvent(event) {
            if (segment) {
                await (0, track_event_1.trackEventToSegment)(segment, event, transformLegacyEvent);
            }
        },
        async trackPage(data) {
            await segment?.page('Content', data?.title ?? document.title, {
                label: 'page_viewed',
            }, (0, context_to_options_1.contextToOptions)({ version: 1 }));
        },
    }), [segment, transformLegacyEvent]);
};
exports.useSegmentAnalyticsHandler = useSegmentAnalyticsHandler;
//# sourceMappingURL=analytics-handler.js.map